import { Workbook } from 'exceljs';
import { InviteDetailComponent } from './invite-detail/invite-detail.component';
import { BulkInviteComponent } from './bulk-invite/bulk-invite.component';
import { IndividualInviteComponent } from './individual-invite/individual-invite.component';
import { InviteComponent } from './invite/invite.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { VmsRoutingModule } from './vms-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { DataService } from '../services/data.service';
import { Ng2SearchFilterModule } from '../_Shared/ng2-search-filter.module';
import { IndividualInviteStatusComponent } from './individual-invite-status/individual-invite-status.component';
import { HistoryComponent } from '../vms/history/history.component';
import { BulkInvitePreviewComponent } from './bulk-invite-preview/bulk-invite-preview.component';
import { ExcelDataProvider } from '../providers/excel.provider';
import { BulkInviteHomeComponent } from './bulk-invite-home/bulk-invite-home.component';
import { InvitationRightsComponent } from './invitation-rights/invitation-rights.component';
import { RequestDetailsComponent } from './request-details/request-details.component';

@NgModule({
  declarations: [InviteComponent, IndividualInviteComponent, BulkInviteComponent, IndividualInviteStatusComponent, InviteDetailComponent, HistoryComponent, BulkInvitePreviewComponent, IndividualInviteComponent, BulkInviteHomeComponent, InvitationRightsComponent, RequestDetailsComponent],
  imports: [
    CommonModule,
    SharedModule,
    VmsRoutingModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    Ng2SearchFilterModule,
    ReactiveFormsModule

  ],
  providers: [DataService, ExcelDataProvider, Workbook]
})
export class VmsModule { }
